import React, { useEffect } from "react";
import hiasan2 from "../../Img/hiasan-2.webp";
import bg12 from "../../Img/bg12.webp";
import ornamenMobile from "../../Img/ornamen.webp";
import ornamenDesktop from "../../Img/ornamendesktop.webp";

import AOS from "aos";
import "aos/dist/aos.css";

export default function Penutup() {
  useEffect(() => {
    AOS.init({
      once: true,
      duration: 1000,
    });
  }, []);

  return (
    <>
      <style>
        {`
          .penutup-section {
            background-image: url(${bg12});
            background-size: cover;
            background-position: center;
            background-attachment: scroll; /* Scroll untuk performa mobile */
            position: relative;
            overflow: hidden;
            width: 100%;
          }
          
          /* Parallax halus hanya diaktifkan di layar desktop/laptop */
          @media (min-width: 768px) {
            .penutup-section {
              background-attachment: fixed; 
            }
          }
        `}
      </style>

      {/* 👇 PERBAIKAN: Menambahkan pb-40 di mobile agar teks tidak tertutup BottomBar 👇 */}
      <div className="penutup-section pt-32 pb-40 md:pb-32">
        {/* ORNAMEN PEMBATAS ATAS */}
        <div className="absolute top-0 left-0 w-full z-[5]">
          <img
            src={ornamenMobile}
            alt="Ornamen Pembatas Mobile"
            className="w-full h-auto object-contain object-top md:hidden block"
          />
          <img
            src={ornamenDesktop}
            alt="Ornamen Pembatas Desktop"
            className="w-full h-auto object-contain object-top hidden md:block"
          />
        </div>

        {/* KONTEN UTAMA */}
        <div className="max-w-4xl mx-auto px-6 md:px-12 relative flex flex-col items-center">
          {/* Hiasan Penutup */}
          <img
            data-aos="fade-down"
            src={hiasan2}
            alt="hiasan"
            className="w-[70px] mb-8 opacity-90"
            style={{
              filter:
                "invert(62%) sepia(85%) saturate(350%) hue-rotate(5deg) brightness(100%) contrast(100%)",
            }}
          />

          {/* Doa / Pesan Penutup */}
          <div data-aos="fade-up" className="text-center mb-16">
            <h2 className="text-[#5C1420] text-3xl md:text-4xl font-bold custom-font-2 mb-6 drop-shadow-sm">
              Doa & Ucapan Syukur
            </h2>

            <p className="text-[#31261d] text-base md:text-lg leading-relaxed font-medium font-serif italic mb-6 max-w-2xl mx-auto">
              "Demikianlah mereka bukan lagi dua, melainkan satu. Karena itu,
              apa yang telah dipersatukan Allah, tidak boleh diceraikan
              manusia."
            </p>
            <p className="text-[#d4af37] font-bold tracking-[0.2em] text-xs uppercase mb-12">
              — Matius 19:6 —
            </p>

            <div className="w-16 h-0.5 bg-[#d4af37] mx-auto mb-10"></div>

            <p className="text-[#413327] text-sm md:text-base leading-relaxed mb-6 font-medium">
              Merupakan suatu kebahagiaan dan kehormatan bagi kami sekeluarga,
              apabila Bapak/Ibu/Saudara/i berkenan hadir untuk memberikan doa
              restu kepada kedua mempelai.
            </p>
            <p className="text-[#5C1420] text-xl font-serif italic font-bold">
              Tuhan Yesus Memberkati.
            </p>
          </div>

          {/* Kotak Nama Keluarga & Mempelai (Glassmorphism) */}
          <div
            data-aos="fade-up"
            data-aos-delay="200"
            className="w-full bg-white/75 backdrop-blur-md border border-[#d4af37]/30 rounded-3xl p-8 md:p-12 shadow-2xl relative z-10"
          >
            {/* 👇 PERBAIKAN: Alfanias & Ruri 👇 */}
            <h1 className="text-center text-[#5C1420] font-bold custom-font-2 text-5xl md:text-7xl mb-12 drop-shadow-sm">
              Alfin & Ruri
            </h1>

            <div className="flex flex-col md:flex-row justify-center md:justify-around items-center gap-10 md:gap-4 text-center">
              {/* Keluarga Pria */}
              <div className="flex flex-col items-center">
                <p className="text-[10px] md:text-xs uppercase tracking-widest text-[#d4af37] font-bold mb-3">
                  Keluarga Mempelai Pria
                </p>
                <p className="text-[#31261d] font-bold text-base md:text-lg leading-relaxed">
                  Bapak Pdt. Martinus Waruwu, S.Th
                </p>
                <p className="text-[#5C1420] font-bold my-1 text-xl">&</p>
                <p className="text-[#31261d] font-bold text-base md:text-lg leading-relaxed">
                  Ibu Surini
                </p>
              </div>

              {/* Pemisah Garis Emas (Desktop) / Garis Kecil (Mobile) */}
              <div className="hidden md:block w-[2px] h-28 bg-gradient-to-b from-transparent via-[#d4af37]/60 to-transparent"></div>
              <div className="md:hidden w-16 h-[2px] bg-gradient-to-r from-transparent via-[#d4af37]/60 to-transparent"></div>

              {/* Keluarga Wanita */}
              <div className="flex flex-col items-center">
                <p className="text-[10px] md:text-xs uppercase tracking-widest text-[#d4af37] font-bold mb-3">
                  Keluarga Mempelai Wanita
                </p>
                <p className="text-[#31261d] font-bold text-base md:text-lg leading-relaxed">
                  Bapak Kapten Inf. Rudi Harianto
                </p>
                <p className="text-[#5C1420] font-bold my-1 text-xl">&</p>
                <p className="text-[#31261d] font-bold text-base md:text-lg leading-relaxed">
                  Ibu Niken Pudji Lestari
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Copyright */}
      {/* Tambahan z-20 dan pb-24 di mobile agar tidak bentrok dengan menu bawah */}
      <div className="bg-[#360810] py-6 pb-28 md:pb-6 text-center relative border-t border-[#d4af37]/20 z-20 mt-[-40px]">
        {/* 👇 PERBAIKAN: Copyright Name 👇 */}
        <p className="text-white/60 text-[10px] md:text-xs font-medium tracking-widest uppercase">
          © 2026 Alfin & Ruri Wedding. All Rights Reserved.
        </p>
        <p className="text-[#d4af37]/60 text-[9px] mt-2 tracking-wider">
          Made with Love
        </p>
      </div>
    </>
  );
}
